require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-bootcamp-alumni-win-people-s-choice-award-at-local-hackathon.json") })
        }
      }, "path---blog-bootcamp-alumni-win-people-s-choice-award-at-local-hackathon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-bootcamp-alumni-win-people-s-choice-award-at-local-hackathon!./.cache/json/blog-bootcamp-alumni-win-people-s-choice-award-at-local-hackathon.json
// module id = 732
// module chunks = 231608221292675